import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { legalApi } from '../lib/api';

export const Footer = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    legalApi.getFooterLinks()
      .then(data => setLinks(Array.isArray(data?.links) ? data.links : []))
      .catch(() => {});
  }, []);

  return (
    <footer className="w-full border-t border-white/5 bg-[#030014]" data-testid="app-footer">
      <div className="w-full px-4 md:px-8 lg:px-[4%] py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-gray-500">
          &copy; {new Date().getFullYear()} Reframes. All rights reserved.
        </p>
        {links.length > 0 && (
          <nav className="flex flex-wrap items-center gap-4" data-testid="footer-links">
            {links.map(link => (
              <Link
                key={link.slug}
                to={`/legal/${link.slug}`}
                className="text-xs text-gray-500 hover:text-[#8B5CF6] transition-colors"
                data-testid={`footer-link-${link.slug}`}
              >
                {link.title}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </footer>
  );
};
